import React from "react";

import { Loader } from "src/components";

const LoginCallback = () => {
  return <Loader />;
};

export default LoginCallback;
